
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Playground } from '@ecl/website-components';
import Icon from '@ecl/eu-react-component-icon';
import demoContentAudio from '@ecl/eu-specs-icon/demo/data--audio';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Playground system="eu" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} mdxType="Icon" />
    </Playground>
    <p>{`You can pick an icon from `}<Link to="/eu/guidelines/iconography/" mdxType="Link">{`the library we provide`}</Link>{`.`}</p>
    <p>{`The ID of the icon is prefixed with its set: for example, the ID of the "audio" icon from the "general" set is `}<inlineCode parentName="p">{`general--audio`}</inlineCode>{`.`}</p>
    <p>{`Note: display of icons on Internet Explorer is made possible by the use of `}<a parentName="p" {...{
        "href": "https://github.com/jonathantneal/svg4everybody"
      }}>{`svg4everybody`}</a></p>
    <h2>{`Color`}</h2>
    <p>{`You can use the default, primary or inverted colours:`}</p>
    <Playground system="eu" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} mdxType="Icon" />
  <Icon {...demoContentAudio} color="primary" mdxType="Icon" />
  <Icon {...demoContentAudio} color="inverted" mdxType="Icon" />
    </Playground>
    <h2>{`Size`}</h2>
    <p>{`You can change the size of the icon by applying one of the following classes:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--xs`}</inlineCode>{`: 16`}{`×`}{`16`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--s`}</inlineCode>{`: 20`}{`×`}{`20`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--m`}</inlineCode>{`: 24`}{`×`}{`24`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--l`}</inlineCode>{`: 32`}{`×`}{`32`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--xl`}</inlineCode>{`: 40`}{`×`}{`40`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--2xl`}</inlineCode>{`: 48`}{`×`}{`48`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--fluid`}</inlineCode>{`: 1em`}</li>
    </ul>
    <Playground system="eu" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} size="xs" mdxType="Icon" />
  <Icon {...demoContentAudio} size="s" mdxType="Icon" />
  <Icon {...demoContentAudio} size="m" mdxType="Icon" />
  <Icon {...demoContentAudio} size="l" mdxType="Icon" />
  <Icon {...demoContentAudio} size="xl" mdxType="Icon" />
  <Icon {...demoContentAudio} size="2xl" mdxType="Icon" />
  <Icon {...demoContentAudio} size="fluid" mdxType="Icon" />
    </Playground>
    <h2>{`Rotate icons`}</h2>
    <p>{`You can rotate icons by adding one of the following classes:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--rotate-0`}</inlineCode>{`: 0 degree`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--rotate-90`}</inlineCode>{`: 90 degrees`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--rotate-180`}</inlineCode>{`: 180 degrees`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ecl-icon--rotate-270`}</inlineCode>{`: 270 degrees`}</li>
    </ul>
    <Playground system="eu" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} transform="rotate-0" mdxType="Icon" />
  <Icon {...demoContentAudio} transform="rotate-90" mdxType="Icon" />
  <Icon {...demoContentAudio} transform="rotate-180" mdxType="Icon" />
  <Icon {...demoContentAudio} transform="rotate-270" mdxType="Icon" />
    </Playground>
    <h2>{`Flip icons`}</h2>
    <p>{`You can flip icons by adding the classes `}<inlineCode parentName="p">{`ecl-icon--flip-horizontal`}</inlineCode>{` or `}<inlineCode parentName="p">{`ecl-icon--flip-vertical`}</inlineCode>{`.`}</p>
    <Playground system="eu" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} transform="flip-horizontal" mdxType="Icon" />
  <Icon {...demoContentAudio} transform="flip-vertical" mdxType="Icon" />
    </Playground>
    <h2>{`Accessibility`}</h2>
    <p>{`If your icon is only used as a decorative element, you don't have to add any special markup.`}</p>
    <p>{`On the other hand, if it's used as an image, you might want to add a couple of extra markup:`}</p>
    <Playground system="ec" selectedKind="components-icon" selectedStory="general" mdxType="Playground">
  <Icon {...demoContentAudio} role="img" aria-hidden="false" title="Title" titleId="example-title" desc="Description" descId="example-desc" mdxType="Icon" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;